import { z } from 'zod'
import { regexField, requiredId, requiredText } from '../../lib/forms/rules'
import { COLUMN_BYTES } from '../../lib/columnBytes'

/** 24 saat biçimi SS:DD (00:00–23:59). */
const TIME_RE = /^([01]\d|2[0-3]):[0-5]\d$/

/**
 * Tutanak temel bilgileri formu (039): grup zorunlu, ad ≤250, tarih (YYYY-MM-DD), başlangıç + bitiş saati
 * (SS:DD), yer ≤250. Katılımcılar ve dokümanlar form dışında (ayrı durum) yönetilir. Tarih + başlangıç saati
 * ve tarih + bitiş saati gönderimde {@code meetingDate}/{@code meetingEndDate} (LocalDateTime) olarak birleştirilir.
 * Bitiş, başlangıçtan sonra olmalıdır (24s SS:DD sıfır-dolgulu → sözlüksel karşılaştırma güvenli).
 */
export const minutesFormSchema = z
  .object({
    meetingGroupId: requiredId(),
    name: requiredText(250, COLUMN_BYTES.meetingName),
    meetingDate: requiredText(),
    meetingStartTime: regexField(TIME_RE, 'validation.time'),
    meetingEndTime: regexField(TIME_RE, 'validation.time'),
    meetingLocation: requiredText(250, COLUMN_BYTES.meetingName),
  })
  .refine((v) => v.meetingStartTime < v.meetingEndTime, {
    path: ['meetingEndTime'],
    message: 'validation.timeRange',
  })

export type MinutesFormValues = z.infer<typeof minutesFormSchema>
